import api from '@/utils/api'

// Conversations
export function createConversation(params, options) {
  return api.post('/ai_agent/conversations', params, options)
}

export function listConversations(params, options) {
  return api.get('/ai_agent/conversations', params, options)
}

export function getConversation(id, options) {
  return api.get(`/ai_agent/conversations/${id}`, null, options)
}

export function updateConversation(id, params, options) {
  return api.put(`/ai_agent/conversations/${id}`, params, options)
}

export function deleteConversation(id, options) {
  return api.delete(`/ai_agent/conversations/${id}`, null, options)
}

// Settings
export function getSettings(options) {
  return api.get('/ai_agent/settings', null, options)
}

export function updateSettings(params, options) {
  return api.put('/ai_agent/settings', params, options)
}

// Usage
export function getUsage(options) {
  return api.get('/ai_agent/usage', null, options)
}

// Tools
export function getTools(options) {
  return api.get('/ai_agent/tools', null, options)
}

// Streaming control
export function stopStreaming(conversationId, options) {
  return api.post(`/ai_agent/conversations/${conversationId}/stop`, {}, options)
}
